module.exports = __webpack_public_path__ + "img/USERS.bae9221f.svg";